// Zusätzliche Leistungen. Seit 30.10.2026 mit den Lampen (vorher eigene Seite): „Lampen ab- und anbringen“ ankreuzen,
// dann die Lampen je Raum direkt darunter angeben.

import { SERVICE_LABEL, SERVICES, type Service } from "@umzugsscan/shared";
import { useDraft, useStore } from "../hooks.ts";
import { useNav } from "../Erfassung.tsx";
import { Check, Footer } from "../ui/elemente.tsx";
import { LampenAngaben, useLampen } from "./Lampen.tsx";

const HINT: Record<Service, string> = {
  kueche: "Wir bauen Ihre Küche ab und in der neuen Wohnung wieder auf.",
  lampen: "Deckenlampen abnehmen und neu anschließen.",
  packservice: "Wir packen Geschirr, Bücher und Kleinteile für Sie ein.",
  kartonanlieferung: "Umzugskartons werden vorab zu Ihnen gebracht.",
};

/** Kunden-Version: Es gibt noch keine Firma, die Leistungen sind Wünsche für die Anfrage (steht im PDF). */
const HINT_PRIVAT: Record<Service, string> = {
  kueche: "Die Küche wird ab- und in der neuen Wohnung wieder aufgebaut.",
  lampen: "Deckenlampen abnehmen und neu anschließen.",
  packservice: "Geschirr, Bücher und Kleinteile werden für Sie eingepackt.",
  kartonanlieferung: "Umzugskartons werden vorab zu Ihnen gebracht.",
};
const LABEL_PRIVAT: Partial<Record<Service, string>> = { packservice: "Packservice (Einpacken durch die Umzugsfirma)" };

export function Leistungen() {
  const d = useDraft();
  const privat = d.company.privat;
  const store = useStore();
  const { weiter, zurueck } = useNav();
  const lampen = useLampen();
  const lampenAn = lampen.l.wanted === true || (lampen.l.wanted == null && d.survey.services.lampen === true);
  // Ab- und Aufbau der Küche steht im Schritt "Küche", wenn es eine gibt.
  const services = SERVICES.filter((s) => s !== "kueche" || !d.rooms.some((r) => r.type === "kueche"));
  return (
    <>
      <h1>{privat ? "Welche Leistungen wünschen Sie?" : "Was dürfen wir zusätzlich übernehmen?"}</h1>
      <p className="lead">
        {privat
          ? "Mehrfachauswahl möglich. Ihre Wünsche stehen in Ihrem PDF; die Umzugsfirma bespricht sie mit Ihnen."
          : "Mehrfachauswahl möglich. Sie können das später noch mit uns besprechen."}
      </p>
      <section className="card">
        {services.map((s) => (
          <Check
            key={s}
            checked={s === "lampen" ? lampenAn : d.survey.services[s] === true}
            onChange={(v) => (s === "lampen" ? lampen.set({ wanted: v }) : store.updateSurvey({ services: { [s]: v } }))}
            hint={(privat ? HINT_PRIVAT : HINT)[s]}
          >
            {(privat ? LABEL_PRIVAT[s] : undefined) ?? SERVICE_LABEL[s]}
          </Check>
        ))}
      </section>
      {lampenAn && (
        <>
          <h2>Welche Lampen sind es?</h2>
          <LampenAngaben />
        </>
      )}
      <div className="field">
        <label htmlFor="note">{privat ? "Noch etwas, das die Umzugsfirma wissen sollte? (optional)" : "Noch etwas, das wir wissen sollten? (optional)"}</label>
        <textarea
          id="note"
          rows={4}
          maxLength={2000}
          placeholder="z. B. enges Treppenhaus, Klavier im 3. Stock, Halteverbot schwierig …"
          value={d.survey.customerNote ?? ""}
          onChange={(e) => store.updateSurvey({ customerNote: e.target.value.trim() ? e.target.value : null })}
        />
      </div>
      <Footer onBack={zurueck} onNext={weiter} />
    </>
  );
}
